!function (e, t) {
  "object" == typeof exports && "object" == typeof module ? module.exports = t(require("react"), require("ati-ui-react/components/InputSubtext"), require("react-select")) : "function" == typeof define && define.amd ? define("ati-ui-react", ["react", "ati-ui-react/components/InputSubtext", "react-select"], t) : "object" == typeof exports ? exports["ati-ui-react"] = t(require("react"), require("ati-ui-react/components/InputSubtext"), require("react-select")) : e["ati-ui-react"] = t(e.React, e[void 0], e[void 0]);
}(this, function (o, r, n) {
  return i = {}, c.m = l = {
    0: function (e, t) {
      e.exports = o;
    },
    115: function (e, t, o) {
      "use strict";

      o.d(t, "a", function () {
        return S;
      });
      var r = o(0),
        l = o.n(r),
        n = o(65),
        i = o.n(n),
        t = o(17),
        a = o.n(t),
        n = o(2),
        t = o.n(n),
        n = o(94),
        o = o.n(n),
        n = {
          insert: "head",
          singleton: !1
        },
        u = (t()(o.a, n), o.a.locals || {});
      function c(e) {
        return (c = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
          return typeof e;
        } : function (e) {
          return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
        })(e);
      }
      function s() {
        return (s = Object.assign || function (e) {
          for (var t = 1; t < arguments.length; t++) {
            var o,
              r = arguments[t];
            for (o in r) Object.prototype.hasOwnProperty.call(r, o) && (e[o] = r[o]);
          }
          return e;
        }).apply(this, arguments);
      }
      function d(e, t) {
        for (var o = 0; o < t.length; o++) {
          var r = t[o];
          r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
        }
      }
      function p(e, t) {
        return (p = Object.setPrototypeOf || function (e, t) {
          return e.__proto__ = t, e;
        })(e, t);
      }
      function f(o) {
        var r = function () {
          if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
          if (Reflect.construct.sham) return !1;
          if ("function" == typeof Proxy) return !0;
          try {
            return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
          } catch (e) {
            return !1;
          }
        }();
        return function () {
          var e,
            t = b(o);
          return e = r ? (e = b(this).constructor, Reflect.construct(t, arguments, e)) : t.apply(this, arguments), t = this, !(e = e) || "object" !== c(e) && "function" != typeof e ? function (e) {
            if (void 0 !== e) return e;
            throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          }(t) : e;
        };
      }
      function b(e) {
        return (b = Object.setPrototypeOf ? Object.getPrototypeOf : function (e) {
          return e.__proto__ || Object.getPrototypeOf(e);
        })(e);
      }
      var S = function () {
        !function (e, t) {
          if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
          e.prototype = Object.create(t && t.prototype, {
            constructor: {
              value: e,
              writable: !0,
              configurable: !0
            }
          }), t && p(e, t);
        }(c, r["Component"]);
        var e,
          t,
          o,
          n = f(c);
        function c() {
          var t;
          !function (e, t) {
            if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
          }(this, c);
          for (var e = arguments.length, o = Array(e), r = 0; r < e; r++) o[r] = arguments[r];
          return (t = n.call.apply(n, [this].concat(o))).state = {
            selectedOption: null
          }, t.handleChange = function (e) {
            t.setState({
              selectedOption: e
            });
          }, t;
        }
        return e = c, (t = [{
          key: "render",
          value: function () {
            var e = this.state.selectedOption,
              t = !!this.props.error && this.props.errorText;
            return l.a.createElement("div", {
              className: [u.select, this.props.className, this.props.error ? "error" : null, this.props.disabled ? "disabled" : null].join(" "),
              "data-qa": this.props.dataQa
            }, l.a.createElement(i.a, s({
              value: e,
              onChange: this.handleChange
            }, this.props)), t && l.a.createElement(a.a, {
              type: "error"
            }, this.props.errorText));
          }
        }]) && d(e.prototype, t), o && d(e, o), c;
      }();
      S.defaultProps = i.a.defaultProps, S.defaultProps.noResultsText = "Результатов не найдено", S.defaultProps.clearable = !1, S.defaultProps.dataQa = "select-v1";
    },
    17: function (e, t) {
      e.exports = r;
    },
    2: function (e, t, n) {
      "use strict";

      var o,
        r,
        i = function () {
          return o = void 0 === o ? !(!(window && document && document.all) || window.atob) : o;
        },
        c = (r = {}, function (e) {
          if (void 0 === r[e]) {
            var t = document.querySelector(e);
            if (window.HTMLIFrameElement && t instanceof window.HTMLIFrameElement) try {
              t = t.contentDocument.head;
            } catch (e) {
              t = null;
            }
            r[e] = t;
          }
          return r[e];
        }),
        u = [];
      function s(e) {
        for (var t = -1, o = 0; o < u.length; o++) if (u[o].identifier === e) {
          t = o;
          break;
        }
        return t;
      }
      function a(e, t) {
        for (var o = {}, r = [], n = 0; n < e.length; n++) {
          var c = e[n],
            l = t.base ? c[0] + t.base : c[0],
            i = o[l] || 0,
            a = "".concat(l, " ").concat(i);
          o[l] = i + 1;
          i = s(a), c = {
            css: c[1],
            media: c[2],
            sourceMap: c[3]
          };
          -1 !== i ? (u[i].references++, u[i].updater(c)) : u.push({
            identifier: a,
            updater: function (t, e) {
              var o, r, n;
              {
                var c;
                n = e.singleton ? (c = S++, o = b = b || d(e), r = f.bind(null, o, c, !1), f.bind(null, o, c, !0)) : (o = d(e), r = function (e, t, o) {
                  var r = o.css,
                    n = o.media,
                    o = o.sourceMap;
                  n ? e.setAttribute("media", n) : e.removeAttribute("media");
                  o && "undefined" != typeof btoa && (r += "\n/*# sourceMappingURL=data:application/json;base64,".concat(btoa(unescape(encodeURIComponent(JSON.stringify(o)))), " */"));
                  if (e.styleSheet) e.styleSheet.cssText = r;else {
                    for (; e.firstChild;) e.removeChild(e.firstChild);
                    e.appendChild(document.createTextNode(r));
                  }
                }.bind(null, o, e), function () {
                  !function (e) {
                    if (null === e.parentNode) return;
                    e.parentNode.removeChild(e);
                  }(o);
                });
              }
              return r(t), function (e) {
                e ? e.css === t.css && e.media === t.media && e.sourceMap === t.sourceMap || r(t = e) : n();
              };
            }(c, t),
            references: 1
          }), r.push(a);
        }
        return r;
      }
      function d(e) {
        var t,
          o = document.createElement("style"),
          r = e.attributes || {};
        if (void 0 !== r.nonce || (t = n.nc) && (r.nonce = t), Object.keys(r).forEach(function (e) {
          o.setAttribute(e, r[e]);
        }), "function" == typeof e.insert) e.insert(o);else {
          e = c(e.insert || "head");
          if (!e) throw Error("Couldn't find a style target. This probably means that the value for the 'insert' parameter is invalid.");
          e.appendChild(o);
        }
        return o;
      }
      var l,
        p = (l = [], function (e, t) {
          return l[e] = t, l.filter(Boolean).join("\n");
        });
      function f(e, t, o, r) {
        o = o ? "" : r.media ? "@media ".concat(r.media, " {").concat(r.css, "}") : r.css;
        e.styleSheet ? e.styleSheet.cssText = p(t, o) : (r = document.createTextNode(o), (o = e.childNodes)[t] && e.removeChild(o[t]), o.length ? e.insertBefore(r, o[t]) : e.appendChild(r));
      }
      var b = null,
        S = 0;
      e.exports = function (e, c) {
        (c = c || {}).singleton || "boolean" == typeof c.singleton || (c.singleton = i());
        var l = a(e = e || [], c);
        return function (e) {
          if ("[object Array]" === Object.prototype.toString.call(e = e || [])) {
            for (var t = 0; t < l.length; t++) {
              var o = s(l[t]);
              u[o].references--;
            }
            for (var e = a(e, c), r = 0; r < l.length; r++) {
              var n = s(l[r]);
              0 === u[n].references && (u[n].updater(), u.splice(n, 1));
            }
            l = e;
          }
        };
      };
    },
    4: function (e, t) {
      e.exports = function () {
        var l = [];
        return l.toString = function () {
          for (var e = [], t = 0; t < this.length; t++) {
            var o = this[t];
            o[2] ? e.push("@media " + o[2] + "{" + o[1] + "}") : e.push(o[1]);
          }
          return e.join("");
        }, l.i = function (e, t) {
          "string" == typeof e && (e = [[null, e, ""]]);
          for (var o = {}, r = 0; r < this.length; r++) {
            var n = this[r][0];
            "number" == typeof n && (o[n] = !0);
          }
          for (r = 0; r < e.length; r++) {
            var c = e[r];
            "number" == typeof c[0] && o[c[0]] || (t && !c[2] ? c[2] = t : t && (c[2] = "(" + c[2] + ") and (" + t + ")"), l.push(c));
          }
        }, l;
      };
    },
    419: function (e, t, o) {
      "use strict";

      o.r(t);
      o = o(115);
      console.warn('Please use \'import Select from "ati-ui-react/components/Select"'), t.default = o.a;
    },
    65: function (e, t) {
      e.exports = n;
    },
    94: function (e, t, o) {
      (t = e.exports = o(4)()).push([e.i, "._3cWn1-2-0-721 .Select{position:relative}._3cWn1-2-0-721 .Select,._3cWn1-2-0-721 .Select div,._3cWn1-2-0-721 .Select input,._3cWn1-2-0-721 .Select span{box-sizing:border-box}._3cWn1-2-0-721 .Select.is-disabled>.Select-control{background-color:#f9f9f9}._3cWn1-2-0-721 .Select.is-disabled>.Select-control:hover{box-shadow:none}._3cWn1-2-0-721 .Select.is-disabled .Select-arrow-zone{cursor:default;pointer-events:none}._3cWn1-2-0-721 .Select-control{background-color:#fff;border-color:#d9d9d9 #ccc #b3b3b3;border-radius:4px;border:1px solid #ccc;color:#333;cursor:default;display:table;height:36px;outline:0;overflow:hidden;position:relative;width:100%}._3cWn1-2-0-721 .Select-control:hover{box-shadow:0 1px 0 rgba(0,0,0,.06)}._3cWn1-2-0-721 .is-searchable.is-open>.Select-control{cursor:text}._3cWn1-2-0-721 .is-open>.Select-control{border-bottom-right-radius:0;border-bottom-left-radius:0;background:#fff;border-color:#b3b3b3 #ccc #d9d9d9}._3cWn1-2-0-721 .is-open>.Select-control>.Select-arrow{border-color:transparent transparent #999;border-width:0 5px 5px}._3cWn1-2-0-721 .is-searchable.is-focused:not(.is-open)>.Select-control{cursor:text}._3cWn1-2-0-721 .is-focused:not(.is-open)>.Select-control{border-color:#007eff;box-shadow:inset 0 1px 1px rgba(0,0,0,.075),0 0 0 3px rgba(0,126,255,.1)}._3cWn1-2-0-721 .Select--single>.Select-control .Select-value,._3cWn1-2-0-721 .Select-placeholder{bottom:0;color:#aaa;left:0;line-height:34px;padding-left:10px;padding-right:10px;position:absolute;right:0;top:0;max-width:100%;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}._3cWn1-2-0-721 .has-value.is-pseudo-focused.Select--single>.Select-control>.Select-value .Select-value-label,._3cWn1-2-0-721 .has-value.Select--single>.Select-control>.Select-value .Select-value-label{color:#333}._3cWn1-2-0-721 .has-value.is-pseudo-focused.Select--single>.Select-control>.Select-value a.Select-value-label,._3cWn1-2-0-721 .has-value.Select--single>.Select-control>.Select-value a.Select-value-label{cursor:pointer;text-decoration:none}._3cWn1-2-0-721 .has-value.is-pseudo-focused.Select--single>.Select-control>.Select-value a.Select-value-label:focus,._3cWn1-2-0-721 .has-value.is-pseudo-focused.Select--single>.Select-control>.Select-value a.Select-value-label:hover,._3cWn1-2-0-721 .has-value.Select--single>.Select-control>.Select-value a.Select-value-label:focus,._3cWn1-2-0-721 .has-value.Select--single>.Select-control>.Select-value a.Select-value-label:hover{color:#007eff;outline:0;text-decoration:underline}._3cWn1-2-0-721 .Select-input{height:34px;padding-left:10px;padding-right:10px;vertical-align:middle}._3cWn1-2-0-721 .Select-input>input{width:100%;background:none transparent;border:0 none;box-shadow:none;cursor:default;display:inline-block;font-family:inherit;font-size:inherit;margin:0;outline:0;line-height:14px;padding:8px 0 12px;-webkit-appearance:none;-moz-appearance:none;appearance:none}._3cWn1-2-0-721 .is-focused .Select-input>input{cursor:text}._3cWn1-2-0-721 .has-value.is-pseudo-focused .Select-input{opacity:0}._3cWn1-2-0-721 .Select-control:not(.is-searchable)>.Select-input{outline:0}._3cWn1-2-0-721 .Select-loading-zone{cursor:pointer;display:table-cell;position:relative;text-align:center;vertical-align:middle;width:16px}._3cWn1-2-0-721 .Select-loading{-webkit-animation:Select-animation-spin .4s infinite linear;animation:Select-animation-spin .4s infinite linear;width:16px;height:16px;box-sizing:border-box;border-radius:50%;border:2px solid #ccc;border-right-color:#333;display:inline-block;position:relative;vertical-align:middle}._3cWn1-2-0-721 .Select-clear-zone{-webkit-animation:Select-animation-fadeIn .2s;animation:Select-animation-fadeIn .2s;color:#999;cursor:pointer;display:table-cell;position:relative;text-align:center;vertical-align:middle;width:17px}._3cWn1-2-0-721 .Select-clear-zone:hover{color:#d0021b}._3cWn1-2-0-721 .Select-clear{display:inline-block;font-size:18px;line-height:1}._3cWn1-2-0-721 .Select--multi .Select-clear-zone{width:17px}._3cWn1-2-0-721 .Select-arrow-zone{cursor:pointer;display:table-cell;position:relative;text-align:center;vertical-align:middle;width:25px;padding-right:5px}._3cWn1-2-0-721 .Select-arrow{border-color:#999 transparent transparent;border-style:solid;border-width:5px 5px 2.5px;display:inline-block;height:0;width:0}._3cWn1-2-0-721 .is-open .Select-arrow,._3cWn1-2-0-721 .Select-arrow-zone:hover>.Select-arrow{border-top-color:#666}@-webkit-keyframes _1c9z7-2-0-721{0%{opacity:0}to{opacity:1}}@keyframes _1c9z7-2-0-721{0%{opacity:0}to{opacity:1}}._3cWn1-2-0-721 .Select-menu-outer{border-bottom-right-radius:4px;border-bottom-left-radius:4px;background-color:#fff;border:1px solid #ccc;border-top-color:#e6e6e6;box-shadow:0 1px 0 rgba(0,0,0,.06);box-sizing:border-box;max-height:200px;top:100%;width:100%;z-index:1;-webkit-overflow-scrolling:touch}._3cWn1-2-0-721 .Select-menu{max-height:198px;overflow-y:auto}._3cWn1-2-0-721 .Select-option{box-sizing:border-box;background-color:#fff;color:#666;cursor:pointer;display:block;padding:8px 10px}._3cWn1-2-0-721 .Select-option:last-child{border-bottom-right-radius:4px;border-bottom-left-radius:4px}._3cWn1-2-0-721 .Select-option.is-selected{background-color:#f5faff;background-color:rgba(0,126,255,.04);color:#333}._3cWn1-2-0-721 .Select-option.is-focused{background-color:#ebf5ff;background-color:rgba(0,126,255,.08);color:#333}._3cWn1-2-0-721 .Select-option.is-disabled{color:#ccc;cursor:default}._3cWn1-2-0-721 .Select-noresults{box-sizing:border-box;color:#999;cursor:default;display:block;padding:8px 10px}._3cWn1-2-0-721 .Select--multi .Select-input{vertical-align:middle;margin-left:10px;padding:0}._3cWn1-2-0-721 .Select--multi.has-value .Select-input{margin-left:5px}._3cWn1-2-0-721 .Select--multi .Select-value{background-color:#ebf5ff;background-color:rgba(0,126,255,.08);border-radius:2px;border:1px solid rgba(0,126,255,.24);color:#007eff;display:inline-block;font-size:.9em;line-height:1.4;margin-left:5px;margin-top:5px;vertical-align:top}._3cWn1-2-0-721 .Select--multi .Select-value-icon,._3cWn1-2-0-721 .Select--multi .Select-value-label{display:inline-block;vertical-align:middle}._3cWn1-2-0-721 .Select--multi .Select-value-label{border-bottom-right-radius:2px;border-top-right-radius:2px;cursor:default;padding:2px 5px}._3cWn1-2-0-721 .Select--multi a.Select-value-label{color:#007eff;cursor:pointer;text-decoration:none}._3cWn1-2-0-721 .Select--multi a.Select-value-label:hover{text-decoration:underline}._3cWn1-2-0-721 .Select--multi .Select-value-icon{cursor:pointer;border-bottom-left-radius:2px;border-top-left-radius:2px;border-right:1px solid #c2e0ff;border-right:1px solid rgba(0,126,255,.24);padding:1px 5px 3px}._3cWn1-2-0-721 .Select--multi .Select-value-icon:focus,._3cWn1-2-0-721 .Select--multi .Select-value-icon:hover{background-color:#d8eafd;background-color:rgba(0,113,230,.08);color:#0071e6}._3cWn1-2-0-721 .Select--multi .Select-value-icon:active{background-color:#c2e0ff;background-color:rgba(0,126,255,.24)}._3cWn1-2-0-721 .Select--multi.is-disabled .Select-value{background-color:#fcfcfc;border:1px solid #e3e3e3;color:#333}._3cWn1-2-0-721 .Select--multi.is-disabled .Select-value-icon{cursor:not-allowed;border-right:1px solid #e3e3e3}._3cWn1-2-0-721 .Select--multi.is-disabled .Select-value-icon:active,._3cWn1-2-0-721 .Select--multi.is-disabled .Select-value-icon:focus,._3cWn1-2-0-721 .Select--multi.is-disabled .Select-value-icon:hover{background-color:#fcfcfc}@-webkit-keyframes yktuu-2-0-721{to{transform:rotate(1turn)}}@keyframes yktuu-2-0-721{to{transform:rotate(1turn)}}._3cWn1-2-0-721 .Select{font-family:Verdana,Dejavu Sans,Geneva,Tahoma,sans-serif;font-size:12px;color:#39444f;line-height:1.4;border-color:#ccc}._3cWn1-2-0-721 .Select:hover:not(.is-disabled) .Select-control{border-color:#8c969d}._3cWn1-2-0-721 .Select:hover:not(.is-disabled) .Select-arrow{opacity:1}._3cWn1-2-0-721 .Select:not(.is-disabled) .Select-control{cursor:pointer}._3cWn1-2-0-721 .Select.is-disabled .Select-value-label{color:#b8b8b8}._3cWn1-2-0-721 .Select.is-disabled .Select-control{background-color:#f1f1f1;cursor:not-allowed}._3cWn1-2-0-721 .Select.is-focused .Select-control{border-color:#8c969d;box-shadow:0 1px 2px 0 rgba(0,0,0,.21)}._3cWn1-2-0-721 .Select.is-focused .Select-arrow{opacity:1}._3cWn1-2-0-721 .Select.is-focused .Select-arrow-zone{margin-bottom:0}._3cWn1-2-0-721 .Select.is-open .Select-arrow{transform:rotate(180deg);margin-bottom:-2px}._3cWn1-2-0-721 .Select.Select--single>.Select-control .Select-value{line-height:30px;color:#39444f;padding-right:17px}._3cWn1-2-0-721 .Select.Select--multi{line-height:1.2}._3cWn1-2-0-721 .Select-value+div[aria-expanded]{outline:0}._3cWn1-2-0-721 .Select-control{border-radius:2px;border-color:#ccc;height:32px;display:flex;z-index:10}._3cWn1-2-0-721 .Select-control:hover{box-shadow:none}._3cWn1-2-0-721 .Select-multi-value-wrapper{margin-right:auto}._3cWn1-2-0-721 .Select-input{height:30px;margin-left:5px;padding:0;padding-left:5px}._3cWn1-2-0-721 .Select-placeholder{margin-top:-1px;line-height:32px;padding-left:10px;color:#b8b8b8}._3cWn1-2-0-721 .Select-menu-outer{border-bottom-right-radius:2px;border-bottom-left-radius:2px;border:1px solid #8c969d;box-shadow:0 1px 2px 0 rgba(0,0,0,.21);margin-top:-1px;position:absolute;left:0;right:0;width:auto;z-index:11}._3cWn1-2-0-721 .Select-menu-outer .Select-option{padding-top:7px;padding-bottom:7px;word-wrap:break-word;color:#39444f}._3cWn1-2-0-721 .Select-menu-outer .Select-option.is-disabled{color:#39444f;opacity:.5;cursor:not-allowed}._3cWn1-2-0-721 .Select-arrow-zone{line-height:24px;padding-right:2px}._3cWn1-2-0-721 .Select-arrow{border-color:#596e81 transparent transparent;margin-bottom:-4px;opacity:.5;height:7px;border-width:5px 5px 2px}._3cWn1-2-0-721 .Select-clear{padding-top:6px}._3cWn1-2-0-721.error>.Select .Select-control,._3cWn1-2-0-721.error>.Select .Select-control:hover{background-color:#fff0f2;border:1px solid #d0021b}._3cWn1-2-0-721.error>.Select .Select-control .Select-value-label{color:#39444f}._3cWn1-2-0-721.error>.is-open .Select-control{background-color:#fff!important;border-color:#8c969d}._3cWn1-2-0-721.error>.is-open .Select-control:hover{border-color:#8c969d}", ""]), t.locals = {
        select: "_3cWn1-2-0-721",
        "Select-animation-fadeIn": "_1c9z7-2-0-721",
        "Select-animation-spin": "yktuu-2-0-721"
      };
    }
  }, c.c = i, c.d = function (e, t, o) {
    c.o(e, t) || Object.defineProperty(e, t, {
      enumerable: !0,
      get: o
    });
  }, c.r = function (e) {
    "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
      value: "Module"
    }), Object.defineProperty(e, "__esModule", {
      value: !0
    });
  }, c.t = function (t, e) {
    if (1 & e && (t = c(t)), 8 & e) return t;
    if (4 & e && "object" == typeof t && t && t.__esModule) return t;
    var o = Object.create(null);
    if (c.r(o), Object.defineProperty(o, "default", {
      enumerable: !0,
      value: t
    }), 2 & e && "string" != typeof t) for (var r in t) c.d(o, r, function (e) {
      return t[e];
    }.bind(null, r));
    return o;
  }, c.n = function (e) {
    var t = e && e.__esModule ? function () {
      return e.default;
    } : function () {
      return e;
    };
    return c.d(t, "a", t), t;
  }, c.o = function (e, t) {
    return Object.prototype.hasOwnProperty.call(e, t);
  }, c.p = "", c(c.s = 419);
  function c(e) {
    if (i[e]) return i[e].exports;
    var t = i[e] = {
      i: e,
      l: !1,
      exports: {}
    };
    return l[e].call(t.exports, t, t.exports, c), t.l = !0, t.exports;
  }
  var l, i;
});